const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
    || (process.env.NODE_ENV === "development" ? "/qouiz/api" : "/api");

export function apiUrl(endpoint) {
    return `${API_BASE_URL.replace(/\/+$/, "")}/${endpoint.replace(/^\/+/, "")}`;
}

export async function readApiJson(response, serviceName) {
    try {
        return await response.json();
    } catch {
        const contentType = response.headers.get("content-type") || "unknown content type";
        const isHtml = contentType.toLowerCase().includes("text/html");
        const responseFormat = isHtml ? "an HTML page" : `a non-JSON response (${contentType})`;
        const guidance = response.status === 404
            ? "Verify that the PHP host has the requested endpoint in its /api/ directory."
            : "The PHP host must return JSON directly, without a browser verification page.";

        throw new Error(
            `${serviceName} returned ${responseFormat} (HTTP ${response.status}). ` +
            guidance
        );
    }
}
